"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var uid_1 = __importDefault(require("./uid"));
var Neuron = /** @class */ (function () {
    function Neuron() {
        this.inputConnections = [];
        this.outputConnections = [];
        this.bias = 0;
        // delta is used to store a percentage of change in the weight
        this.delta = 0;
        this.output = 0;
        this.error = 0;
        this.id = (0, uid_1.default)();
    }
    Neuron.prototype.toJSON = function () {
        return {
            id: this.id,
            delta: this.delta,
            output: this.output,
            error: this.error,
            bias: this.bias,
            inputConnections: this.inputConnections.map(function (i) { return i.toJSON(); }),
            outputConnections: this.outputConnections.map(function (i) { return i.toJSON(); })
        };
    };
    Neuron.prototype.getRandomBias = function () {
        var min = -3;
        var max = 3;
        return Math.floor(Math.random() * (+max - +min)) + min;
    };
    Neuron.prototype.addInputConnection = function (connection) {
        this.inputConnections.push(connection);
    };
    Neuron.prototype.addOutputConnection = function (connection) {
        this.outputConnections.push(connection);
    };
    Neuron.prototype.setBias = function (val) {
        this.bias = val;
    };
    Neuron.prototype.setOutput = function (val) {
        this.output = val;
    };
    Neuron.prototype.setDelta = function (val) {
        this.delta = val;
    };
    Neuron.prototype.setError = function (val) {
        this.error = val;
    };
    return Neuron;
}());
exports.default = Neuron;
